import { useGetTeamInvitees } from '@/hooks/useGetTeamInvitees'
import Invitee from './InviteeComponent'
import { Stack } from './custom-components'
import { Skeleton } from './shadcn/skeleton'

const UserProfileDialogTeamInvitees = ({ teamId }: { teamId: string }) => {
  const { isLoadingTeamInvitees, teamInvitees } = useGetTeamInvitees({ teamId })

  // If no loading and no data, render nothing
  if (!isLoadingTeamInvitees && !teamInvitees) {
    return null
  }

  // Render loading skeletons
  if (isLoadingTeamInvitees) {
    return (
      <>
        {[...Array(5)].map((_, index) => (
          <div key={index} className="flex justify-between items-center gap-10 w-full">
            <div className="flex items-center gap-3 w-full">
              <Skeleton className="h-8 w-8 rounded-full" />
              <Stack className="gap-2 w-full">
                <Skeleton className="h-4 w-full max-w-[250px]" />
                <Skeleton className="h-4 w-full max-w-[200px]" />
              </Stack>
            </div>
          </div>
        ))}
      </>
    )
  }

  // If data is available but empty, render nothing
  if (!teamInvitees) {
    return null
  }

  // Render invitees that are not accepted
  const pendingInvitees = teamInvitees.filter((invitee) => invitee.status !== 'accepted')

  if (pendingInvitees.length === 0) {
    return null
  }

  return (
    <>
      {pendingInvitees.map((member) => (
        <Invitee member={member} />
      ))}
    </>
  )
}

export default UserProfileDialogTeamInvitees
